import React from 'react';
import { MdOutlineAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

interface MainAddButtonProps {
  to: string;
  label: string;
  id?: string;
  disabled?: boolean;
  soft?: boolean;
  onClick?: () => void; // if needed to override navigation
  iconSize?: string | number;
  className?: string;
}

const MainAddButton: React.FC<MainAddButtonProps> = ({
  to,
  label,
  id,
  disabled = false,
  soft = false,
  onClick,
  iconSize = '20px',
  className = '',
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick && to !== '') {
      onClick();
      navigate(to);
    } else if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };
  // const handleClick = () => {
  //   if (onClick) {
  //     onClick();
  //   } else {
  //     navigate(to);
  //   }
  // };

  return (
    <button
      type="button"
      className={`btn ${
        soft ? 'btn-soft-success' : 'btn-success'
      } add-btn ${className}`}
      id={id}
      disabled={disabled}
      onClick={handleClick}
    >
      <MdOutlineAdd fontSize={iconSize} className="me-1 align-bottom" />
      {label}
    </button>
  );
};

export default MainAddButton;
